import React from "react";

export default function OrderNotes({ singleOrder }) {
  return (
    <div className="row mt-3">
      <div className="col-md-7">
        <div className="mb-3">
          <label className="mb-0">Order Category:</label>
          {singleOrder?.order_items?.map((item, key) =>
            item.category ? (
              <div key={key}>
                <h5 className="mb-4"> {item.category}</h5>
              </div>
            ) : (
              <h5 key={key} className="mb-4">
                Not Available
              </h5>
            )
          )}
        </div>
        <div className="mb-3">
          <label className="mb-0">Customer Comment:</label>
          <h5 className="mb-4">
            {singleOrder.customer_comment || "No comments"}
          </h5>
        </div>
        <div className="o-desc">
          <label className="mb-0 ">Order Description:</label>
          <h5 className="mb-4">
            {singleOrder.order_description || "No description"}
          </h5>
        </div>
      </div>
    </div>
  );
}
